<template>
  <button
    ref="rtButton"
    :disabled="computedDisabled || loading"
    :autofocus="autofocus"
    :class="classes"
    type="button"
    class="rt-button"
    @click="handleClick"
  >
    <div v-if="isLoading" class="rt-button-content">
      <rt-icon name="rt-base-loading" :size="loadingSize" />
      <div class="loading-save">
        {{ loadingText }}
      </div>
    </div>

    <span v-else class="rt-button-content">
      <rt-icon v-if="iconName" :name="iconName" :size="iconSize" />
      <span v-if="hasdefault" class="rt-button-text"><slot></slot></span>
      <rt-divider v-if="hasDivider" :direction="direction" />
      <rt-icon v-if="suffixIcon" :name="suffixIcon" :size="iconSize" />
    </span>
    <rt-tooltip
      v-if="tooltip"
      ref="rtButtonTooltip"
      popper-class="rt-button-tooltip"
      :content="String(tooltip)"
      placement="bottom"
    >
      <div style="position: absolute; top: -1px; left: -1px"></div>
    </rt-tooltip>
  </button>
</template>

<script>
import RtIcon from "../icon/rtIcon";
import RtDivider from "../divider/rtDivider.vue";
export default {
  name: "RtButton",
  inject: {
    elForm: {
      default: "",
    },
    elFormItem: {
      default: "",
    },
  },
  components: {
    RtIcon,
    RtDivider,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default() {
        return this.$tx("正在保存", "xpc.common.saving");
      },
    },
    loadingSize: {
      type: Number,
      default: 16,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: "",
    },
    suffixIcon: {
      type: String,
      default: "",
    },
    iconSize: {
      type: String,
      default: "16",
    },
    size: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "default",
    },
    colorType: {
      type: String,
      default: "normal",
    },
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean,
    text: Boolean,
    background: Boolean,
    divider: Boolean,
    /**
     * @public 分隔线方向
     */
    direction: {
      type: String,
      default: "vertical",
    },
    click: Function,
    // eslint-disable-next-line vue/require-prop-types
    tagData: {
      required: false,
    },
    tooltip: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isDisabled: this.disabled,
      isLoading: this.loading,
    };
  },
  computed: {
    _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    /**
     * @deprecated
     */
    buttonDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    computedDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    hasDivider() {
      return this.divider;
    },
    classes() {
      let {
        type,
        buttonSize,
        colorType,
        computedDisabled,
        loading,
        round,
        circle,
        text,
        hasdefault,
        background,
      } = this;
      return [
        type ? "rt-button--" + type : "",
        buttonSize ? "rt-button--" + buttonSize : "rt-button--medium",
        colorType ? "rt-button--" + colorType : "",
        {
          "is-disabled": computedDisabled,
          "is-loading": loading,
          "is-round": round,
          "is-circle": circle,
          "is-text": text,
          "no-text": !hasdefault,
          "is-background": background,
        },
      ];
    },
    hasdefault() {
      return this.$slots.default;
    },
  },
  watch: {
    loading(newValue) {
      this.isLoading = newValue;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.tooltip && this.$refs.rtButton && this.$refs.rtButtonTooltip) {
        const { width, height } = this.$refs.rtButton.getBoundingClientRect();
        this.$refs.rtButtonTooltip.$el.style.width = width;
        this.$refs.rtButtonTooltip.$el.style.height = height;
      }
    });
  },
  methods: {
    async handleClick(event) {
      if (
        this.click &&
        Object.prototype.toString.call(this.click) === "[object Function]"
      ) {
        try {
          this.isDisabled = true;
          this.isLoading = true;
          await this.click();
        } catch (error) {
        } finally {
          this.isDisabled = false;
          this.isLoading = false;
        }
      } else {
        this.$emit("click", event, this.tagData);
      }
    },
  },
};
</script>
<style scoped>
.rt-button--primary {
  background-color: #004c97 !important;
}
</style>


// WEBPACK FOOTER //
// rtButton.vue?a30cce3c